import { Component, OnInit } from '@angular/core';
import { OroService } from '../oro.service';

import { OroCounty } from '../domain/OroCounty';
import { OroState } from '../domain/OroState';
// import { HelloResult } from '../domain/HelloResult';
import { InitHubResult } from '../domain/InitHubResult';
import { ConfigService } from '../config.service';

@Component({
  selector: 'app-hub',
  templateUrl: './hub.component.html',
  styleUrls: ['./hub.component.css']
})
export class HubComponent implements OnInit {

  selectUrl: string;
  isDisabled = true;
  activeId: string = "panelOne";

  public pageStatement: string = '';
  public availableCounties: Array<OroCounty> = new Array<OroCounty>();
  public availableStates: Array<OroState> = new Array<OroState>();

  public selectedCounty: OroCounty = new OroCounty();
  public selectedState: OroState = new OroState();

  public filteredCounties: Array<OroCounty> = new Array<OroCounty>();

  constructor(private oroService: OroService, private configService: ConfigService) { 

    this.selectUrl = configService.config.selectUrl;
  }

//   ngOnInit(): void {

//     this.oroService.getHello<HelloResult>('test 123').subscribe(
//     (result: HelloResult) => {
//       if (result.Success) {

//         this.pageStatement = result.Message;
//       } else {
//         alert(result.Message);
//       }
//     }
//     );

// }

  ngOnInit(): void {

    console.log('hub.component');

    this.isDisabled = true;

    this.oroService.initHub<InitHubResult>().subscribe(
      (result: InitHubResult) => {
        if (result.Success) {

          this.pageStatement = result.PageStatement;

          this.availableStates = new Array<OroState>();
          result.States.forEach(x => {

            const lvItem = new OroState();
            lvItem.Id = x.Id;
            lvItem.Code = x.Code;
            lvItem.Name = x.Name;

            this.availableStates.push(lvItem);
          });

          this.availableCounties = new Array<OroCounty>();
          result.Counties.forEach(x => {

            const lvItem = new OroCounty();
            lvItem.Id = x.Id;
            lvItem.Name = x.Name;
            lvItem.State = x.State;

            this.availableCounties.push(lvItem);
          });

          this.availableCounties.sort((a, b) => a.Name > b.Name ? 1 : a.Name == b.Name ? 0 : -1);
          this.availableStates.sort((a, b) => a.Name > b.Name ? 1 : a.Name == b.Name ? 0 : -1);
        } else {
          alert(result.Message);
        }
      }
    );
  }
  
  onChangeState(selected: any) {

    this.isDisabled = true;
    this.selectedCounty = new OroCounty();
    this.selectedState = new OroState();
    this.filteredCounties = new Array<OroCounty>();

    if (selected.target.value.length > 0) {

      this.selectedState = this.availableStates.filter(x => x.Id == Number(selected.target.value))[0];
      this.filteredCounties = this.availableCounties.filter(x => x.State == this.selectedState.Code);

      this.activeId = "panelTwo";
    } else {

      alert('You must select a state');
    }
  }

  onChangeCounty(selected: any) {

    this.isDisabled = true;
    this.selectedCounty = new OroCounty();

    if (selected.target.value.length > 0) {

      this.selectedCounty = this.availableCounties.filter(x => x.Id == Number(selected.target.value))[0];

      this.isDisabled = !this.selectedCounty || !this.selectedState;
    } else {

      alert('You must select a county');
    }
  }

  gotoSelectCounty() {

    this.isDisabled = true;

    let url = this.selectUrl + '?state=' + this.selectedCounty.State + '&county=' + this.selectedCounty.Name;
        
    window.location.href = url;
  }

  getActiveId() {

    return this.activeId;
  }
}
